/* tslint:disable */
/* eslint-disable */
/**
 * TOM OPERATIONS SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { CreateHatchCoverMoveCommand } from '../model'
// @ts-ignore
import type { HatchCoverMoveDto } from '../model'
// @ts-ignore
import type { UpdateHatchCoverMoveCommand } from '../model'
/**
 * HatchCoverMovesApi - axios parameter creator
 */
export const HatchCoverMovesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    _delete: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('_delete', 'id', id)
      const localVarPath = `/operations/api/HatchCoverMoves/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {CreateHatchCoverMoveCommand} [createHatchCoverMoveCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    create: async (
      createHatchCoverMoveCommand?: CreateHatchCoverMoveCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/HatchCoverMoves`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createHatchCoverMoveCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {number} [vesselVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHatchCoverMovesByVesselVisitId: async (
      vesselVisitId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/HatchCoverMoves/GetHatchCoverMovesByVesselVisitId`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (vesselVisitId !== undefined) {
        localVarQueryParameter['VesselVisitId'] = vesselVisitId
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {UpdateHatchCoverMoveCommand} [updateHatchCoverMoveCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    update: async (
      updateHatchCoverMoveCommand?: UpdateHatchCoverMoveCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/HatchCoverMoves`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateHatchCoverMoveCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * HatchCoverMovesApi - functional programming interface
 */
export const HatchCoverMovesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = HatchCoverMovesApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async _delete(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator._delete(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['HatchCoverMovesApi._delete']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {CreateHatchCoverMoveCommand} [createHatchCoverMoveCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async create(
      createHatchCoverMoveCommand?: CreateHatchCoverMoveCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.create(
        createHatchCoverMoveCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['HatchCoverMovesApi.create']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {number} [vesselVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getHatchCoverMovesByVesselVisitId(
      vesselVisitId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HatchCoverMoveDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getHatchCoverMovesByVesselVisitId(
        vesselVisitId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['HatchCoverMovesApi.getHatchCoverMovesByVesselVisitId']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {UpdateHatchCoverMoveCommand} [updateHatchCoverMoveCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async update(
      updateHatchCoverMoveCommand?: UpdateHatchCoverMoveCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.update(
        updateHatchCoverMoveCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['HatchCoverMovesApi.update']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * HatchCoverMovesApi - factory interface
 */
export const HatchCoverMovesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = HatchCoverMovesApiFp(configuration)
  return {
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    _delete(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp._delete(id, options).then(request => request(axios, basePath))
    },
    /**
     *
     * @param {CreateHatchCoverMoveCommand} [createHatchCoverMoveCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    create(
      createHatchCoverMoveCommand?: CreateHatchCoverMoveCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<number> {
      return localVarFp
        .create(createHatchCoverMoveCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {number} [vesselVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHatchCoverMovesByVesselVisitId(
      vesselVisitId?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<HatchCoverMoveDto>> {
      return localVarFp
        .getHatchCoverMovesByVesselVisitId(vesselVisitId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {UpdateHatchCoverMoveCommand} [updateHatchCoverMoveCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    update(
      updateHatchCoverMoveCommand?: UpdateHatchCoverMoveCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .update(updateHatchCoverMoveCommand, options)
        .then(request => request(axios, basePath))
    },
  }
}

/**
 * HatchCoverMovesApi - object-oriented interface
 */
export class HatchCoverMovesApi extends BaseAPI {
  /**
   *
   * @param {number} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public _delete(id: number, options?: RawAxiosRequestConfig) {
    return HatchCoverMovesApiFp(this.configuration)
      ._delete(id, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {CreateHatchCoverMoveCommand} [createHatchCoverMoveCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public create(
    createHatchCoverMoveCommand?: CreateHatchCoverMoveCommand,
    options?: RawAxiosRequestConfig,
  ) {
    return HatchCoverMovesApiFp(this.configuration)
      .create(createHatchCoverMoveCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {number} [vesselVisitId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getHatchCoverMovesByVesselVisitId(
    vesselVisitId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return HatchCoverMovesApiFp(this.configuration)
      .getHatchCoverMovesByVesselVisitId(vesselVisitId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {UpdateHatchCoverMoveCommand} [updateHatchCoverMoveCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public update(
    updateHatchCoverMoveCommand?: UpdateHatchCoverMoveCommand,
    options?: RawAxiosRequestConfig,
  ) {
    return HatchCoverMovesApiFp(this.configuration)
      .update(updateHatchCoverMoveCommand, options)
      .then(request => request(this.axios, this.basePath))
  }
}
